import React, { useContext } from "react";
import { Link } from "gatsby";
import styled from "@emotion/styled";
import { mediaQueriesMax } from "@src/styles/theme";
import { css } from "@emotion/core";
import { logEvent } from "@src/utils/logClient";
import { ModalContext, ModalType } from "@src/components/modals/ModalController";
import { AppDataContext } from "@src/components/AppDataContext";

const Hero = styled("div")`
  width: calc(100% + 2px);
  height: 300px;
  margin: -1px -1px 0 -1px;

  ${mediaQueriesMax.lesson} {
    height: 114px;
  }
`;

const HeroContainer = styled("div")`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 100%;
  height: 300px;
  border-radius: 8px 8px 0 0;

  border-bottom: 1px solid #e2e2e2;

  overflow: hidden;

  ${mediaQueriesMax.lesson} {
    height: 114px;
  }
`;

const HeroPoster = styled(`img`)`
  width: 100%;
`;

const heroAction = css`
  position: absolute;
  top: 300px;
  right: 71px;

  display: flex;
  align-items: center;
  justify-content: center;

  width: 159px;
  height: 48px;
  margin: 40px 20px 0 20px;
  border-radius: 8px;
  background-color: #00aeef;

  font-size: 16px;
  font-weight: bold;
  text-align: center;
  color: #ffffff;
  line-height: 1;

  ${mediaQueriesMax.lesson} {
    top: unset;
    bottom: -88px;
    left: 0;

    width: calc(100% - 40px);
  }

  &:hover {
    cursor: pointer;
    background-color: #00baff;
  }
`;

function LessonHero(props) {
  const appData = useContext(AppDataContext);
  const type = props.header_type;

  if (type !== "video") {
    return <Image {...props} />;
    return <VideoBlocker {...props} />;
  }
  return <Video {...props} />;
  return <VideoBlocker {...props} />;
}

function Image(props) {
  let button = null;

  if (props.showButton || props.showButton === undefined) {
    button = (
      <Link
        to={`/f/${props.slug}`}
        css={heroAction}
        onClick={() => {
          logEvent({
            eventName: "ideas.activityStart",
            eventValue: props.slug,
          });
        }}
      >
        Start activity
      </Link>
    );
  }

  return (
    <Hero>
      <HeroContainer>
        <HeroPoster src={props.header_poster_url.localFile.publicURL} />
      </HeroContainer>
      {button}
    </Hero>
  );
}

function Video(props) {
  let button = null;

  if (props.showButton) {
    button = (
      <Link to={`/f/${props.slug}`} data-test-name="videoStartActivityButton" css={heroAction}>
        Start activity
      </Link>
    );
  }

  return (
    <Hero>
      <HeroContainer>
        <HeroPoster src={props.header_poster_url.localFile.publicURL} />
      </HeroContainer>
      {button}
    </Hero>
  );
}

function VideoBlocker(props) {
  const modals = useContext(ModalContext);

  const button = <div css={heroAction}>Start activity</div>;

  return (
    <Hero onClick={() => modals.showModal(ModalType.TeacherSignup)}>
      <HeroContainer>
        <HeroPoster src={props.header_poster_url.localFile.publicURL} />
      </HeroContainer>
      {props.header_type == "video" && button}
    </Hero>
  );
}

export default LessonHero;
